import { render, staticRenderFns } from "./charmRiskRegisterTL.vue?vue&type=template&id=603c2c80"
import script from "./charmRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./charmRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('603c2c80')) {
      api.createRecord('603c2c80', component.options)
    } else {
      api.reload('603c2c80', component.options)
    }
    module.hot.accept("./charmRiskRegisterTL.vue?vue&type=template&id=603c2c80", function () {
      api.rerender('603c2c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/timeline/charmRiskRegisterTL.vue"
export default component.exports